<template>
<!-- Main Wrapper -->
        <div class="main-wrapper blank-page">
        
            <!-- Header -->
                <layout-header />
            <!-- /Header -->

            <div class="overflow-hidden bg-light bg-cover bg-no-repeat pb-md-5 pb-4 rounded-none position-relative w-100 features-img"
                :style="'padding-top: 120px;background-position:center;background-image: url('+require('@/assets/img/bg-hero.jpg')+');'">
                <div class="container px-4 py-3 mx-auto position-relative" style="z-index: 1">
                    <h2 class="text-center text-white my-5 display-3 fw-bold">Contact</h2>
                </div>
            </div>
            
            <!-- Page Content -->
            <div class="content" style="margin-top: 2rem;">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-10 col-xl-10 pb-5">
                            
                            <!-- Description -->
                            <div class="text-center mb-5 mt-4">
                                <p class="text-muted">
                                    Une question, une suggestion ou besoin d'aide ? Notre équipe est à votre écoute.<br/>
                                    Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais.
                                </p>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 py-3">
                                    <h2 class="mb-4">Envoyez-nous un message</h2>
                                    <div class="card border-0 shadow-sm rounded-xl bg-light p-3" style="margin-bottom: 0;">
                                        <div class="card-body p-2">
                                            <form @submit.prevent="contact">
                                                <div class="form-group mb-3">
                                                    <label class="fw-bold mb-1">Nom</label>
                                                    <input v-model="name" type="text" class="form-control rounded-pill px-3 py-2 border-0 small" placeholder="Entrez votre nom" required>
                                                </div>
                                                <div class="form-group mb-3">
                                                    <label class="fw-bold mb-1">Email</label>
                                                    <input v-model="email" type="email" class="form-control rounded-pill px-3 py-2 border-0 small" placeholder="Entrez votre adresse email" required>
                                                </div>
                                                <div class="form-group mb-3">
                                                    <label class="fw-bold mb-1">Message</label>
                                                    <textarea v-model="message" class="form-control rounded-xl px-3 py-2 border-0 small" rows="4" placeholder="Entrez votre message" required></textarea>
                                                </div>
                                                <div class="submit-section">
                                                    <button class="btn btn-primary btn-block btn-lg btn-rounded" type="submit">
                                                        <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                                        <label class="m-0 mx-1 d-flex justify-content-center align-items-center">
                                                            <i class="material-icons-outlined align-middle mr-2" style="font-size: 18px;">send</i> Envoyer
                                                        </label>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 d-flex align-items-center justify-content-center">
                                    <img :src="require('@/assets/img/step2.jpg')" alt="Contact" class="img-fluid rounded-xl mb-4">
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-4 mb-3">
                                    <div class="card border-0 shadow-sm rounded-lg text-center p-3">
                                        <div class="card-body p-2">
                                            <i class="material-icons-outlined text-primary mb-2" style="font-size: 36px;">email</i>
                                            <h6 class="fw-bold mb-1">Email</h6>
                                            <p class="text-muted mb-0 small">contact@6v6foot.com</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="card border-0 shadow-sm rounded-lg text-center p-3">
                                        <div class="card-body p-2">
                                            <i class="material-icons-outlined text-primary mb-2" style="font-size: 36px;">phone</i>
                                            <h6 class="fw-bold mb-1">Téléphone</h6>
                                            <p class="text-muted mb-0 small">+216 95 654 666</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <div class="card border-0 shadow-sm rounded-lg text-center p-3">
                                        <div class="card-body p-2">
                                            <i class="material-icons-outlined text-primary mb-2" style="font-size: 36px;">location_on</i>
                                            <h6 class="fw-bold mb-1">Adresse</h6>
                                            <p class="text-muted mb-0 small">Nouvelle Médina - Ben Arous, 2063</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>      
            <!-- /Page Content -->

            <!-- Footer -->
                <layout-footer />
            <!-- /Footer -->

            </div>
</template>
<script>
import { api } from '@/store';

export default {
    data() {
        return {
            name: '',
            email: '',
            message: '',
        }
    },
    computed: {
        errorMessages() {
            return this.$store.getters.errorMessages;
        },
    },
    methods: {
        async contact() {
            this.clearForm();
            let payload = { name: this.name, email: this.email, message: this.message };
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await api.post('/public/contact', payload)
                .then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: 'Message envoyé avec succès.',
                    })
                    // Reset form
                    this.name = '';
                    this.email = '';
                    this.message = '';
                })
                .catch(error => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Erreur',
                        detail: "Une erreur s'est produite lors de l'envoi du message.",
                    })
                })
                .finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                });
            
            if (Object.keys(this.errorMessages).length > 0 || this.error) {
                const inputs = $("#name, #email, #message");
                inputs.each(function () {
                    const $input = $(this);
                    $input.addClass('is-invalid');
                    $input.closest('.form-group').find('.invalid-feedback').remove();
                    $input.closest('.form-group').append(
                        '<span class="invalid-feedback mt-0" role="alert">Erreur lors de l\'envoi du message</span>'
                    );
                });
            }
        },
        clearForm() {
            $('.invalid-feedback').remove();
            $('.form-control.is-invalid').removeClass('is-invalid');
        }
    },
mounted() {
// Content div min height set
    
    function resizeInnerDiv() {
        var height = $(window).height();    
        var header_height = $(".header").height();
        var footer_height = $(".footer").height();
        var breadcrumb_height = $(".breadcrumb-bar").height();
        var setheight = height - breadcrumb_height - header_height;
        var trueheight = setheight - footer_height;
        $(".content").css("min-height", trueheight - 30);
    }
    
    if($('.content').length > 0 ){
        resizeInnerDiv();
    }

    $(window).resize(function(){
        if($('.content').length > 0 ){
            resizeInnerDiv();
        }
    }); 
}
}
</script>